import React from 'react'
import { linkedin, github } from '../assets/icons'
function Footer() {
  return (
    <div className=" flex justify-center items-center flex-col text-6xl p-6 h-5/4 bg-blackGreen">
      <div className=" flex justify-center items-center">
      <div className='ease-in-out duration-300 hover:invert'>
        <a href="https://www.linkedin.com/in/ismael-hern%C3%A1ndez-46b09523a/">
          <img src={linkedin} alt="linkedin" className='w-12 mx-6'/>
        </a>
      </div>
      <div className=' ease-in-out duration-300 hover:invert'>
        <a href="https://github.com/Issmaa">
          <img src={github} alt="github" className='w-12'/>
        </a>
      </div>
      </div>
      <p className='text-sm md:text-lg m-4'>All rights reserved. Ismael Hernandez 2023 ©</p>
    </div>
  )
}

export default Footer